var map = {
	"./icons/add.svg": 65228,
	"./icons/add_new_shift_image.svg": 54852,
	"./icons/administration.svg": 77338,
	"./icons/amex.svg": 4405,
	"./icons/announcement.svg": 14752,
	"./icons/application.svg": 88221,
	"./icons/arrow-down.svg": 51061,
	"./icons/arrow-up.svg": 58704,
	"./icons/arrow_down_circle.svg": 98365,
	"./icons/attendances.svg": 15657,
	"./icons/bin.svg": 44561,
	"./icons/blue-filled-question.svg": 37393,
	"./icons/brand_mark.svg": 90388,
	"./icons/brand_mark_light.svg": 26762,
	"./icons/brand_word_client_user.svg": 18335,
	"./icons/brand_word_mark_horizontal.svg": 86926,
	"./icons/brand_word_mark_horizontal_light.svg": 89182,
	"./icons/calendar.svg": 24095,
	"./icons/camera.svg": 47563,
	"./icons/cancel.svg": 32392,
	"./icons/chat.svg": 74738,
	"./icons/check_circle.svg": 50987,
	"./icons/check_solid.svg": 22151,
	"./icons/circular_cross.svg": 57003,
	"./icons/client_sign_in_image.svg": 36156,
	"./icons/clients.svg": 50347,
	"./icons/clock.svg": 50993,
	"./icons/close.svg": 58790,
	"./icons/comment.svg": 59874,
	"./icons/community.svg": 36896,
	"./icons/community_sign_in_image.svg": 7918,
	"./icons/cross.svg": 89609,
	"./icons/dashboard.svg": 17024,
	"./icons/down.svg": 6591,
	"./icons/download-disabled.svg": 90419,
	"./icons/download.svg": 73146,
	"./icons/download_app_store_badge.svg": 24603,
	"./icons/download_google_play_badge.svg": 2476,
	"./icons/edit.svg": 53881,
	"./icons/edit_calendar.svg": 51824,
	"./icons/email_live_chat.svg": 66664,
	"./icons/error.svg": 37922,
	"./icons/event_calendar.svg": 94903,
	"./icons/event_checked.svg": 26678,
	"./icons/exclamation_mark.svg": 43009,
	"./icons/expand-less.svg": 82915,
	"./icons/expand-more.svg": 11898,
	"./icons/external_link.svg": 17495,
	"./icons/face.svg": 61574,
	"./icons/fat_zebra.svg": 48128,
	"./icons/favicon.svg": 74310,
	"./icons/filled-question.svg": 49353,
	"./icons/help.svg": 16791,
	"./icons/inbound_calling.svg": 25078,
	"./icons/info-primary-900.svg": 88172,
	"./icons/info-primary.svg": 52074,
	"./icons/infos.svg": 37136,
	"./icons/jobs.svg": 42608,
	"./icons/left.svg": 21473,
	"./icons/loading-circle.svg": 67985,
	"./icons/mastercard.svg": 98690,
	"./icons/menu.svg": 6451,
	"./icons/message.svg": 55513,
	"./icons/minus.svg": 29111,
	"./icons/monash_admin_logo.svg": 34450,
	"./icons/monash_community_sign_in_image.svg": 36785,
	"./icons/monash_favicon.svg": 72738,
	"./icons/monash_logo.svg": 64899,
	"./icons/monash_logo_white.svg": 75496,
	"./icons/objection_handling.svg": 21128,
	"./icons/organization_sign_in_image.svg": 35560,
	"./icons/outbound_calling.svg": 97035,
	"./icons/paper.svg": 34963,
	"./icons/password_reset_image.svg": 50265,
	"./icons/pay_rates.svg": 45094,
	"./icons/pencil.svg": 56211,
	"./icons/phone.svg": 54399,
	"./icons/plus.svg": 68970,
	"./icons/positions.svg": 85442,
	"./icons/primary_logo_dark.svg": 76367,
	"./icons/primary_logo_light.svg": 69572,
	"./icons/public_holidays.svg": 18586,
	"./icons/reception_work.svg": 83250,
	"./icons/report.svg": 3491,
	"./icons/reporting.svg": 74728,
	"./icons/right.svg": 72743,
	"./icons/save.svg": 7955,
	"./icons/search.svg": 30223,
	"./icons/see_more.svg": 41347,
	"./icons/sleeping_peppa.svg": 33384,
	"./icons/sms.svg": 21926,
	"./icons/subtract.svg": 92248,
	"./icons/thumbs-down.svg": 36934,
	"./icons/thumbs-up.svg": 89379,
	"./icons/timesheets.svg": 18103,
	"./icons/unread_message.svg": 131,
	"./icons/up.svg": 73076,
	"./icons/visa.svg": 21991,
	"./icons/weployees.svg": 123,
	"./icons/weployers.svg": 91033,
	"./illustrations/accept_reject_extension.svg": 85910,
	"./illustrations/adding_phone_number.svg": 50844,
	"./illustrations/beef_hotpot.svg": 15086,
	"./illustrations/checklist_with_pencil.svg": 5340,
	"./illustrations/client_account_setup.svg": 17335,
	"./illustrations/computer_and_plant.svg": 93667,
	"./illustrations/dancing_peoples.svg": 78581,
	"./illustrations/dancing_peoples_with_furniture.svg": 64109,
	"./illustrations/inbox.svg": 52131,
	"./illustrations/lady_and_man_standing_with_furniture.svg": 11656,
	"./illustrations/lady_showcasing_webpage.svg": 98602,
	"./illustrations/lady_using_laptop_by_bookshelf.svg": 96226,
	"./illustrations/lady_using_laptop_on_table.svg": 82822,
	"./illustrations/lady_with_laptop_in_beads_sofa.svg": 35746,
	"./illustrations/laptop_desk_with_chair.svg": 51871,
	"./illustrations/man_help_women_ideal.svg": 51810,
	"./illustrations/man_holding_laptop.svg": 48394,
	"./illustrations/man_with_pc.svg": 34928,
	"./illustrations/mfa_setting.svg": 77621,
	"./illustrations/monash_client_account_setup_background.svg": 8738,
	"./illustrations/monash_client_sign_in_image.svg": 12514,
	"./illustrations/monash_empty_image.svg": 10360,
	"./illustrations/monash_people_and_bookcase.svg": 86801,
	"./illustrations/monash_unlock_potential_image.svg": 99845,
	"./illustrations/people_and_bookcase.svg": 19018,
	"./illustrations/people_holding_laptop.svg": 51365,
	"./illustrations/people_in_living_room.svg": 29302,
	"./illustrations/people_talking.svg": 51834,
	"./illustrations/people_talking_with_laptop.svg": 54498,
	"./illustrations/peppa.svg": 84310,
	"./illustrations/person_using_computer_by_the_windows.svg": 63661,
	"./illustrations/person_using_laptop_on_invisible_table.svg": 94141,
	"./illustrations/purple_woman_at_computer.svg": 548,
	"./illustrations/resend_client_company_invitation_image.svg": 81252,
	"./illustrations/standing_lady_using_laptop.svg": 34948,
	"./illustrations/timesheet_approved_image.svg": 40676,
	"./illustrations/two_friends_dancing.svg": 88375,
	"./illustrations/two_people_chatting.svg": 46942,
	"./illustrations/two_people_chatting_2.svg": 49571,
	"./illustrations/vacant_desk.svg": 43950,
	"./illustrations/wave.svg": 15074,
	"./illustrations/weployees-not-found.svg": 51176,
	"./illustrations/woman-chill.svg": 49102,
	"./illustrations/woman-happy.svg": 46159,
	"./illustrations/women_find_self_ideal.svg": 43798,
	"./illustrations/women_man_with_pc.svg": 17091,
	"icons/add.svg": 65228,
	"icons/add_new_shift_image.svg": 54852,
	"icons/administration.svg": 77338,
	"icons/amex.svg": 4405,
	"icons/announcement.svg": 14752,
	"icons/application.svg": 88221,
	"icons/arrow-down.svg": 51061,
	"icons/arrow-up.svg": 58704,
	"icons/arrow_down_circle.svg": 98365,
	"icons/attendances.svg": 15657,
	"icons/bin.svg": 44561,
	"icons/blue-filled-question.svg": 37393,
	"icons/brand_mark.svg": 90388,
	"icons/brand_mark_light.svg": 26762,
	"icons/brand_word_client_user.svg": 18335,
	"icons/brand_word_mark_horizontal.svg": 86926,
	"icons/brand_word_mark_horizontal_light.svg": 89182,
	"icons/calendar.svg": 24095,
	"icons/camera.svg": 47563,
	"icons/cancel.svg": 32392,
	"icons/chat.svg": 74738,
	"icons/check_circle.svg": 50987,
	"icons/check_solid.svg": 22151,
	"icons/circular_cross.svg": 57003,
	"icons/client_sign_in_image.svg": 36156,
	"icons/clients.svg": 50347,
	"icons/clock.svg": 50993,
	"icons/close.svg": 58790,
	"icons/comment.svg": 59874,
	"icons/community.svg": 36896,
	"icons/community_sign_in_image.svg": 7918,
	"icons/cross.svg": 89609,
	"icons/dashboard.svg": 17024,
	"icons/down.svg": 6591,
	"icons/download-disabled.svg": 90419,
	"icons/download.svg": 73146,
	"icons/download_app_store_badge.svg": 24603,
	"icons/download_google_play_badge.svg": 2476,
	"icons/edit.svg": 53881,
	"icons/edit_calendar.svg": 51824,
	"icons/email_live_chat.svg": 66664,
	"icons/error.svg": 37922,
	"icons/event_calendar.svg": 94903,
	"icons/event_checked.svg": 26678,
	"icons/exclamation_mark.svg": 43009,
	"icons/expand-less.svg": 82915,
	"icons/expand-more.svg": 11898,
	"icons/external_link.svg": 17495,
	"icons/face.svg": 61574,
	"icons/fat_zebra.svg": 48128,
	"icons/favicon.svg": 74310,
	"icons/filled-question.svg": 49353,
	"icons/help.svg": 16791,
	"icons/inbound_calling.svg": 25078,
	"icons/info-primary-900.svg": 88172,
	"icons/info-primary.svg": 52074,
	"icons/infos.svg": 37136,
	"icons/jobs.svg": 42608,
	"icons/left.svg": 21473,
	"icons/loading-circle.svg": 67985,
	"icons/mastercard.svg": 98690,
	"icons/menu.svg": 6451,
	"icons/message.svg": 55513,
	"icons/minus.svg": 29111,
	"icons/monash_admin_logo.svg": 34450,
	"icons/monash_community_sign_in_image.svg": 36785,
	"icons/monash_favicon.svg": 72738,
	"icons/monash_logo.svg": 64899,
	"icons/monash_logo_white.svg": 75496,
	"icons/objection_handling.svg": 21128,
	"icons/organization_sign_in_image.svg": 35560,
	"icons/outbound_calling.svg": 97035,
	"icons/paper.svg": 34963,
	"icons/password_reset_image.svg": 50265,
	"icons/pay_rates.svg": 45094,
	"icons/pencil.svg": 56211,
	"icons/phone.svg": 54399,
	"icons/plus.svg": 68970,
	"icons/positions.svg": 85442,
	"icons/primary_logo_dark.svg": 76367,
	"icons/primary_logo_light.svg": 69572,
	"icons/public_holidays.svg": 18586,
	"icons/reception_work.svg": 83250,
	"icons/report.svg": 3491,
	"icons/reporting.svg": 74728,
	"icons/right.svg": 72743,
	"icons/save.svg": 7955,
	"icons/search.svg": 30223,
	"icons/see_more.svg": 41347,
	"icons/sleeping_peppa.svg": 33384,
	"icons/sms.svg": 21926,
	"icons/subtract.svg": 92248,
	"icons/thumbs-down.svg": 36934,
	"icons/thumbs-up.svg": 89379,
	"icons/timesheets.svg": 18103,
	"icons/unread_message.svg": 131,
	"icons/up.svg": 73076,
	"icons/visa.svg": 21991,
	"icons/weployees.svg": 123,
	"icons/weployers.svg": 91033,
	"illustrations/accept_reject_extension.svg": 85910,
	"illustrations/adding_phone_number.svg": 50844,
	"illustrations/beef_hotpot.svg": 15086,
	"illustrations/checklist_with_pencil.svg": 5340,
	"illustrations/client_account_setup.svg": 17335,
	"illustrations/computer_and_plant.svg": 93667,
	"illustrations/dancing_peoples.svg": 78581,
	"illustrations/dancing_peoples_with_furniture.svg": 64109,
	"illustrations/inbox.svg": 52131,
	"illustrations/lady_and_man_standing_with_furniture.svg": 11656,
	"illustrations/lady_showcasing_webpage.svg": 98602,
	"illustrations/lady_using_laptop_by_bookshelf.svg": 96226,
	"illustrations/lady_using_laptop_on_table.svg": 82822,
	"illustrations/lady_with_laptop_in_beads_sofa.svg": 35746,
	"illustrations/laptop_desk_with_chair.svg": 51871,
	"illustrations/man_help_women_ideal.svg": 51810,
	"illustrations/man_holding_laptop.svg": 48394,
	"illustrations/man_with_pc.svg": 34928,
	"illustrations/mfa_setting.svg": 77621,
	"illustrations/monash_client_account_setup_background.svg": 8738,
	"illustrations/monash_client_sign_in_image.svg": 12514,
	"illustrations/monash_empty_image.svg": 10360,
	"illustrations/monash_people_and_bookcase.svg": 86801,
	"illustrations/monash_unlock_potential_image.svg": 99845,
	"illustrations/people_and_bookcase.svg": 19018,
	"illustrations/people_holding_laptop.svg": 51365,
	"illustrations/people_in_living_room.svg": 29302,
	"illustrations/people_talking.svg": 51834,
	"illustrations/people_talking_with_laptop.svg": 54498,
	"illustrations/peppa.svg": 84310,
	"illustrations/person_using_computer_by_the_windows.svg": 63661,
	"illustrations/person_using_laptop_on_invisible_table.svg": 94141,
	"illustrations/purple_woman_at_computer.svg": 548,
	"illustrations/resend_client_company_invitation_image.svg": 81252,
	"illustrations/standing_lady_using_laptop.svg": 34948,
	"illustrations/timesheet_approved_image.svg": 40676,
	"illustrations/two_friends_dancing.svg": 88375,
	"illustrations/two_people_chatting.svg": 46942,
	"illustrations/two_people_chatting_2.svg": 49571,
	"illustrations/vacant_desk.svg": 43950,
	"illustrations/wave.svg": 15074,
	"illustrations/weployees-not-found.svg": 51176,
	"illustrations/woman-chill.svg": 49102,
	"illustrations/woman-happy.svg": 46159,
	"illustrations/women_find_self_ideal.svg": 43798,
	"illustrations/women_man_with_pc.svg": 17091
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50888;